import React, { useMemo } from 'react';
import MeetingRow from './MeetingRow';

export default function MeetingTable({ Year: year, Data: data }) {
  const groupedByDate = useMemo(() => {
    const map = new Map();
    for (const d of data) {
      if (!map.has(d.Date)) {
        map.set(d.Date, []);
      }
      map.get(d.Date).push(d);
    }
    //console.log("here!",map)
    return Array.from(map.entries());
  }, [data]);

  return (
    <table className="table table-striped table-bordered align-middle">
      <thead>
        <tr>
          <th className="text-light" style={{ minWidth: 100, backgroundColor: '#1F497D' }}>{year}</th>
          <th className="text-light" style={{ backgroundColor: '#1F497D' }}>Notices</th>
          <th className="text-light" style={{ backgroundColor: '#1F497D' }}>Agendas</th>
          <th className="text-light" style={{ minWidth: 220, backgroundColor: '#1F497D' }}>Meeting Materials</th>
          <th className="text-light" style={{ backgroundColor: '#1F497D' }}>Minutes</th>
        </tr>
      </thead>
      <tbody>
        {groupedByDate.map(([date, meetings]) => (
          <MeetingRow key={date} date={date} meetings={meetings} />
        ))}
      </tbody>
    </table>
  );
}